import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"


import editModalProvince from './editModalProvince.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref } from 'vue'
import { adminAreaFindByPage, adminAreaDelete } from '@/api/gucangSales/administrativeRegion'
import { adminAreaSaveParams, adminAreaFindByPageParams } from '@/typings/api/gucangSale'
import { DcMessage } from '@dc-platform/dc-components'

const __default__ = { name: 'list' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref()
const tableRef = ref()
const queryForm = reactive<adminAreaFindByPageParams>({})

// onMounted(() => {
// })
// 获取列表
const fetch = (params: adminAreaFindByPageParams, callBack: (res: any) => void) => {
  adminAreaFindByPage({
    ...params,
    level: 2
  }).then((res) => {
    callBack(res)
  })
}
const success = () => {
  tableRef.value.fetch()
}
const columns = ref([
  { title: '国家二字码', dataIndex: 'countryCharCode' },
  { title: '国家中文名', dataIndex: 'countryCnName' },
  { title: '省/州', dataIndex: 'provinceName' },
  { title: '创建人', dataIndex: 'operatorName' },
  { title: '创建时间', dataIndex: 'operationTime' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: adminAreaSaveParams) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: adminAreaSaveParams) => {
  Modal.delete({
    name: row.countryCharCode,
    onOk() {
      adminAreaDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value?.delFetch()
      })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_cos_table, {
      serial: "",
      columns: columns.value,
      onFetch: fetch,
      search: queryForm,
      "onUpdate:search": _cache[3] || (_cache[3] = ($event: any) => ((queryForm) = $event)),
      ref_key: "tableRef",
      ref: tableRef,
      tableId: "DcCosProvinceList"
    }, {
      search: _withCtx(() => [
        _createVNode(_component_a_form, { model: queryForm }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              name: "name",
              label: "国家二字码"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: queryForm.countryCharCode,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.countryCharCode) = $event)),
                  allowClear: "",
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              name: "name",
              label: "省 / 州"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: queryForm.provinceName,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.provinceName) = $event)),
                  allowClear: "",
                  placeholder: "请输入"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      bodyCell: _withCtx(({ column, record }) => [
        (column.dataIndex === 'action')
          ? (_openBlock(), _createBlock(_component_more_button, { key: 0 }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "link",
                  onClick: ($event: any) => (addEdit(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("编辑")
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'base_adminregion_edit_btn']
                ]),
                _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                  type: "link",
                  onClick: ($event: any) => (deleteRow(record))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除")
                  ]),
                  _: 2
                }, 1032, ["onClick"])), [
                  [_directive_permission, 'base_adminregion_delete_btn']
                ])
              ]),
              _: 2
            }, 1024))
          : _createCommentVNode("", true)
      ]),
      button: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_a_button, {
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (addEdit()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("新增")
          ]),
          _: 1
        })), [
          [_directive_permission, 'base_adminregion_add_btn']
        ])
      ]),
      _: 1
    }, 8, ["columns", "search"]),
    _createVNode(editModalProvince, {
      ref_key: "editModalRef",
      ref: editModalRef,
      onSuccess: success
    }, null, 512)
  ], 64))
}
}

})